var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFailure(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 87.681,
    height: 87.681,
    viewBox: "0 0 87.681 87.681",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_176409",
    "data-name": "Group 176409",
    transform: "translate(-227.604 -134.366)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_24",
    "data-name": "Ellipse 24",
    transform: "translate(233.603 145.582)",
    fill: "none",
    stroke: "#ec2128",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.615,
    cy: 34.615,
    rx: 31.115,
    ry: 31.115,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "+",
    transform: "translate(244.038 180.156) rotate(45)",
    fill: "#e60000",
    stroke: "#e60000",
    strokeWidth: 1,
    fontSize: 64,
    fontFamily: "Roboto-Thin, Roboto",
    fontWeight: 100
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "+")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailure);
export default __webpack_public_path__ + "static/media/Failure.176020706142edbc9832dc799f84fac3.svg";
export { ForwardRef as ReactComponent };